import React from "react";
import { SocketConsumer } from '../SocketContext/SocketContext';

const withSocketContext = WrappedComponent => {
  class WithSocketContext extends React.Component {
    render() {
      return (
        <SocketConsumer>
          {value => <WrappedComponent {...this.props} context={value} />}
        </SocketConsumer>
      );
    }
  };
  return WithSocketContext;
};

export default withSocketContext;
